import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { hexToRGBA } from '@diritto/common/utils/style';

interface NoticeBadgeProps {
  color?: Color;
}

export const NoticeBadge = ({ color = Color.Primary500 }: NoticeBadgeProps) => (
  <StyledWrapper color={color}>
    <p>공지</p>
  </StyledWrapper>
);

const StyledWrapper = styled.span(
  ({ color }: { color: Color }) => css`
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${hexToRGBA(color, 0.2)};
    border-radius: 100px;
    padding: 2px 8px;

    font-weight: ${FontWeight.Bold};
    ${Typography.XXXSmall};

    & > p {
      font-size: 12px;
      line-height: 18px;
      color: ${color};
    }
  `,
);
